<template>
  <div>
    <div class="w3-col content-sidebar-right top-from-header w3-animate-right">
      <i
        class="
          fa fa-times
          w3-xlarge w3-text-gray
          cursor-pointer
          card-closer
          flow-padding-top
          w3-left
        "
        @click="onClose"
      ></i>
      <h4 class="flow-blue-color w3-left zero-left flow-margin-top-3-pct">
        <access-type-badge v-if="!printMode && ((access && access.accessType) || preSelectedAccessType)"
                           :only-icon="true"
                           :access-type="access.accessType || preSelectedAccessType"
                           class="w3-show-inline-block flow-padding-right flow-padding-left">
        </access-type-badge>
        <i v-else class="fa fa-universal-access w3-margin-right"></i>
        <b v-if="isQuickPrint">{{$t("quickPrintAccess")}}</b>
        <b v-else-if="!access.accessControlId">{{ $t("addNewAccess") }}</b>
        <b v-else>{{ access.name }}</b>
      </h4>
      <div v-if="!printMode">
        <access-control-patient v-if="showACTypeSelection"
          :accessControlEntries="accessControlEntries"></access-control-patient>
        <access-control-form v-else
          :setPrintTypeAndId="setPrintTypeAndId"
          :reload="reload"
          :selectedAccess="access"
          :preSelectedAccessType = "preSelectedAccessType"
          :onClose="onClose"
          :openNewAccess="openNewAccess"
          :togglePrint="togglePrint"
          :openAndRetrieveAccess="openAndRetrieveAccess"
          :openAndRetrieveAndPrintAccess="openAndRetrieveAndPrintAccess"
          class="w-90pc flow-margin-auto"
        ></access-control-form>
      </div>
      <div v-else>
        <access-control-print
          :accessType="printType"
          :accessControlId="printId"
          :togglePrint="togglePrint"
          :isQuickPrint="isQuickPrint"
          :onClose="onClose"
        ></access-control-print>
      </div>
    </div>
  </div>
</template>

<script>
import AccessControlForm from "./AccessControlForm";
import AccessControlPrint from "./AccessControlPrint.vue";
import Vue from "vue";
import AccessControlPatient from "@/components/access-control/AccessControlPatient";
import {EventBus} from "@/main";
import AccessTypeBadge from "@/components/access-control/AccessTypeBadge";

const frc = Vue.prototype.$frc;
export default {
  components: {AccessTypeBadge, AccessControlPatient, AccessControlForm, AccessControlPrint },
  props: ["access", "preSelectedAccessType","onClose", "reload", "openNewAccess","isQuickPrint",
          "openAndRetrieveAccess","keepPrintOpen","endKeepPrintOpen","openAndRetrieveAndPrintAccess"],
  data() {
    return {
      printMode: false,
      printId:"",
      printType:"",
      accessType:'',
      showACTypeSelection: true,
      accessControlEntries: []
    };
  },
  mounted() {
    if(this.isQuickPrint){
        this.printMode = true;
    }
    EventBus.$on("hideACTypeSelectionScreen", () => {
      this.showACTypeSelection = false;
    })
    if(this.access.accessControlId)
      this.getAllRelatedAccessControls()
    else this.getAccessTypes();
  },
  watch: {
    access: function(newvalue,oldvalue){
      var app = this;
      if(!app.keepPrintOpen){
        app.printMode=false;
      }
      if(newvalue){
        this.printId=newvalue.accessControlId;
        this.printType = newvalue.accessType;
      }
    },
    keepPrintOpen: function(newValue,oldValue){
      var app = this;
      if(newValue){
        app.printMode=true;
      }
    }
  },
  methods: {
    togglePrint() {
      this.endKeepPrintOpen();
      this.printMode = !this.printMode;
    },
    setPrintTypeAndId(accessType,accessId){
      this.printId=accessId;
      this.printType = accessType;
      this.printMode=true;
    },

    getAllRelatedAccessControls() {
      this.accessControlEntries = [];
      frc.getRelatedAccessControlEntries(this.access.accessControlId).then((response) => {
        if(response.data.length > 0) {
          this.accessControlEntries.push(this.access);
          this.accessControlEntries.push(...response.data);
        }
        else {
          this.showACTypeSelection = false;
        }
      });
    },
    getAccessTypes() {
      var app = this;
      frc.getAllAccessControlTypes().then(function (res) {
        app.accessControlEntries = res.data;
      });
    },
  },
};
</script>